import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=3c24c89d&scoped=true&"
import script from "./NotificationsList.vue?vue&type=script&lang=js&"
export * from "./NotificationsList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=3c24c89d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c24c89d",
  null
  
)

export default component.exports